<template>
  <div
    tabindex="0"
    :class="['c-grid-item', { 'c-grid-item--focused': expand === true }]"
    @focus="onFocus"
    @blur="onBlur"
  >
    <div class="c-grid-item__wrapper">
      <div class="c-grid-item__static" style="min-width: 80px">
        <div class="c-grid-item__dragger">
          <more-vertical-icon size="1x"></more-vertical-icon>
          <more-vertical-icon size="1x"></more-vertical-icon>
        </div>
        <div
          :class="['c-grid-item__control icon', { selected: isSelected }]"
          @click="onSelect($event)"
        >
          <span>
            <check-icon size="1x"></check-icon>
          </span>
        </div>
      </div>
      <div
        class="c-grid-item__column"
        v-for="(column, index) in computedGridColumns"
        :style="
          'width:' + column.width + 'px;min-width:' + column.width + 'px;'
        "
        :key="index"
      >
        <div class="c-grid-item__column__inner" v-if="column.key === 'bucket'">
          <span class="c-grid-item__block">
            <span
              v-if="bucket"
              :title="bucket.title"
              :class="['badge badge--big', 'c' + bucket.color]"
              v-html="bucket.title"
            ></span>
          </span>
        </div>
        <div class="c-grid-item__column__inner" v-if="column.key === 'folder'">
          <span v-if="folder">
            {{ folder.title }}
          </span>
        </div>
        <div class="c-grid-item__column__inner" v-if="column.key === 'date'">
          <span class="c-grid-item__text">
            {{ formatDate(note.createdAt) }}
          </span>
        </div>
        <div
          class="c-grid-item__column__inner expandable"
          v-if="column.key === 'text'"
        >
          <TextRenderer :note="note" />
        </div>
        <div
          class="c-grid-item__column__inner expandable"
          v-if="column.key === 'comment'"
        >
          <span class="c-grid-item__article" v-if="note.comment">
            {{ note.comment.raw }}
          </span>
        </div>
        <div
          class="c-grid-item__column__inner"
          style="width: 300px"
          v-if="column.key === 'controls'"
        >
          <span class="btn btn-link"> Copy </span>
          <span class="btn btn-link"> Edit </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextRenderer from "@/components/dashboard/text-renderer";
import moment from "moment";
import { MoreVerticalIcon, CheckIcon } from "vue-feather-icons";
export default {
  components: {
    MoreVerticalIcon,
    CheckIcon,
    TextRenderer,
  },
  data: function () {
    return {
      expand: false,
    };
  },
  props: ["note", "gridColumns"],
  computed: {
    selectedNotes: function () {
      return this.$store.getters["note/selectedNotes"];
    },
    isSelected: function () {
      if (this.selectedNotes.length < 1) {
        return false;
      }
      if (this.selectedNotes.includes(this.note.id)) {
        return true;
      } else {
        return false;
      }
    },
    computedGridColumns: function () {
      let columns = this.gridColumns;
      return columns;
    },
    bucket: function () {
      if (this.note.bucket) {
        return this.$store.getters["bucket/bucket"](this.note.bucket);
      }
      return null;
    },
    folder: function () {
      if (this.note.folder) {
        return this.$store.getters["folder/folder"](this.note.folder);
      }
      return null;
    },
  },
  methods: {
    columnSort: function (a, b) {
      return a.index - b.index;
    },
    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
    onSelect: function (e) {
      let shiftSelect = false;
      if (e.shiftKey) {
        this.$emit("shiftSelect", this.note);
      } else if (e.ctrlKey) {
        this.$emit("ctrlSelect", this.note);
      } else {
        this.$store.commit("note/TOGGLE_SELECTION", this.note);
      }
    },
    onFocus: function () {
      this.expand = true;
    },
    onBlur: function () {
      this.expand = false;
    },
  },
};
</script>

<style lang="scss">
.c-grid-item {
  position: relative;

  &:focus {
    outline: none;
  }

  &__wrapper {
    display: flex;
    position: relative;
  }

  &__column {
    position: relative;
    //border-right: var(--g4) solid 1px;
    border-bottom: var(--g4) solid 1px;
    //background-color: var(--p4);

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: transparent;
    }

    &__inner {
      height: 100%;
      display: flex;
      justify-content: center;
      max-height: var(--grid-height);
      overflow-y: hidden;
    }
  }

  &__static {
    position: relative;
    border-right: var(--g2) solid 1px;
    background-color: var(--g4);
    display: flex;
    align-items: flex-start;

    .custom-control {
      height: 24px;

      .custom-control-label {
        &:before {
          top: -6px;
        }
        &:after {
          top: -6px;
        }
      }
    }

    &:after {
      content: "";
      position: absolute;
      z-index: 10;
      top: 0;
      left: 0;
      width: 2px;
      height: 100%;
      background-color: transparent;
    }
  }

  &__text {
    display: inline-flex;
    align-items: center;
    padding: $lg-margins / 2 $lg-margins * 2;
    font-size: var(--font-size-xs);
  }

  &__article {
    width: 100%;
    display: inline-block;
    padding: $lg-margins / 2 $lg-margins * 2;
    opacity: 0.85;
  }

  &__block {
    padding: $lg-margins / 2 $lg-margins * 2;
  }

  &__dragger {
    position: relative;
    margin-top: 3px;
    width: 24px;
    height: 24px;
    margin-left: 4px;
    opacity: 0.8;
    transition: opacity 50ms linear;
    cursor: grab;
    svg {
      position: absolute;
      top: calc(50% - 8px);
      left: 0;
      display: inline-block;

      &:last-child {
        left: 6px;
      }
    }

    &:hover,
    &:active {
      opacity: 1;
    }
  }

  .c-text-renderer {
    padding: $lg-margins / 2 $lg-margins * 2;
    width: 100%;

    &--code {
      border-radius: 0;
      border: none;
    }
  }

  &__control {
    position: relative;
    width: 40px;
    cursor: pointer;
    user-select: none;
    margin-top: 16px;

    > span {
      display: block;
      position: absolute;
      bottom: calc(50% - 10px);
      left: 9px;
      width: 20px;
      height: 20px;
      border-radius: 3px;
      background-color: var(--p5);
      border: var(--p4) solid 2px;
      transition: all 60ms linear;

      svg {
        display: block;
        stroke: var(--p5);
        stroke-width: 4px;
      }
    }

    &.first {
      &:after {
        top: auto;
        bottom: 0;
        height: 50%;
      }
    }

    &.last {
      &:after {
        height: 50%;
      }
      &.first {
        &:after {
          content: none;
        }
      }
    }

    &:hover {
      > span {
        background-color: var(--p4);
        border-color: var(--p4);
        svg {
          stroke: var(--p5);
        }
      }
    }
    &.selected {
      background-color: var(--g3);
      z-index: 10;

      > span {
        background-color: var(--p3);
        border-color: var(--p3);
        svg {
          stroke: var(--p5);
        }
      }
    }
  }

  &--focused {
    border-color: var(--s4);
    max-height: var(--grid-height);

    .c-grid-item__wrapper {
      z-index: 1;
      box-shadow: 0 1.3px 3.1px rgba(0, 0, 0, 0.145),
        0 4.5px 10.3px rgba(0, 0, 0, 0.215), 0 20px 46px rgba(0, 0, 0, 0.36);
    }
    .c-grid-item__column {
      background-color: var(--p5);
      border-color: var(--p4);

      &:before {
        background-color: var(--p4);
      }

      &__inner {
        max-height: initial;
      }
    }
    .c-grid-item__static {
      &:after {
        background-color: var(--p3);
      }
    }
  }
}
</style>